var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(!this.hidden)?_c('span',{staticClass:"protein"},[_vm._v("")]):_c('span',{staticClass:"protein"},[_vm._v("")])])
}
var staticRenderFns = []

export { render, staticRenderFns }